import { render, staticRenderFns } from "./assignExperts.vue?vue&type=template&id=0d7c6e74&scoped=true&"
import script from "./assignExperts.vue?vue&type=script&lang=js&"
export * from "./assignExperts.vue?vue&type=script&lang=js&"
import style0 from "./assignExperts.vue?vue&type=style&index=0&id=0d7c6e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c6e74",
  null
  
)

export default component.exports